// Misma regla que backend/utils/creditoVsInmueble.js: se revisa al guardar (no mientras se escribe), solo si ambos campos
// traen valor; crédito igual al inmueble se permite.
export const MENSAJE_CREDITO_INMUEBLE = 'El valor del crédito no puede ser mayor que el valor del inmueble';

const monto = (v) => {
  if (v === undefined || v === null || v === '') return null;
  const n = Number(String(v).replace(/[$,\s]/g, ''));
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const creditoExcedeInmueble = (credito, inmueble) => {
  const c = monto(credito), i = monto(inmueble);
  return c !== null && i !== null && c > i;
};
